// extracted by mini-css-extract-plugin
export default {"tableContainer":"ref-obj-win_tableContainer__yCsaL","noLinks":"ref-obj-win_noLinks__MqyX3"};